import { useState } from 'react';

import {
  DefaultTrackPromotionEvent,
  trackG4ViewPromotion,
} from '@/common/analytics/gtm/shared/trackViewPromotion';
import { ImpressionsContextProvider } from '@/common/impressions';
import ComingSoonView from '@/modules/HomePage/components/ComingSoon/ComingSoonView';
import useHomepageContext from '@/modules/HomePage/HomePageContext';

const ComingSoon = () => {
  const { upcomingEvents } = useHomepageContext();

  const [expiredEvents, setExpiredEvents] = useState<string[]>([]);

  const filteredUpcomingEvents = upcomingEvents.filter(
    (event) => !expiredEvents.includes(event.id),
  );

  if (filteredUpcomingEvents.length === 0) return null;

  return (
    <ImpressionsContextProvider<DefaultTrackPromotionEvent>
      callback={trackG4ViewPromotion}
      shouldSendSeparately
    >
      <ComingSoonView events={filteredUpcomingEvents} setExpiredEvents={setExpiredEvents} />
    </ImpressionsContextProvider>
  );
};

export default ComingSoon;
